import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const LogoContainer = styled(Box)({
  background: 'rgb(157, 156, 181)',
  backgroundSize: '500% 500%',
})
